import React, { useState, useRef } from 'react'

export const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false)
  const formRef = useRef(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = formRef.current
    if (!form) return
    const formData = new FormData(form)
    if (!formData.get("email")) return

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => setSubmitted(true))
      .catch(err => console.error(err))
  }

  return (
    <div className='col-6 m-col-12 grid grid-6 align-start pos-rel'>
      <p className='m-col-6'>Newsletter</p>
      <form ref={formRef} id='newsletter-form' netlify-honeypot='bot-field' name='newsletter' method='POST' data-netlify='true' className='col-4 m-col-6 flex flex-col gap-8 pos-rel' onSubmit={handleSubmit}>
        <input type='hidden' name='form-name' value='newsletter' />
        <input name='bot-field' className='hide' />
        <div className='bb1 w-100 pb8'>
          <input type='email' name='email' placeholder='Email' className='newsletter-input grey' required/>
        </div>
        <p className='grey f-12'>By submitting, you agree to the Terms of Use and Privacy Policy.</p>
      </form>
      <button type='submit' form='newsletter-form' className='pointer'>Submit</button>
      <div className={`newsletter-thanks ${submitted ? 'active' : ''}`}>
        <p>Thank you for subscribing!</p>
      </div>
    </div>
  )
}
